import { stripHtml } from '@/lib/sanitizeHtml'

interface RepliedTo {
  id: number
  body: string | null
  author_type: 'Agent' | 'EndUser' | null
  author_name: string
  attachments_count: number
  deleted: boolean
  image_url?: string | null
}

interface QuotedMessageProps {
  repliedTo: RepliedTo
  onClick?: () => void
  compact?: boolean
}

export default function QuotedMessage({ repliedTo, onClick, compact = false }: QuotedMessageProps) {
  const isAgent = repliedTo.author_type === 'Agent'
  const borderColor = isAgent ? 'border-blue-400' : 'border-gray-400'
  const nameColor = isAgent ? 'text-blue-600' : 'text-gray-600'

  let bodyPreview: string
  if (repliedTo.deleted) {
    bodyPreview = 'Esta mensagem foi removida'
  } else if (repliedTo.body) {
    // Convert block-level closings and <br> to newlines before stripping HTML
    const withBreaks = repliedTo.body
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n')
    bodyPreview = stripHtml(withBreaks).trim()
  } else if (repliedTo.attachments_count > 0) {
    bodyPreview = '📎 Anexo'
  } else {
    bodyPreview = ''
  }

  return (
    <div
      onClick={onClick}
      className={`flex border-l-3 ${borderColor} bg-black/5 rounded-r-lg px-3 py-1.5 ${onClick ? 'cursor-pointer hover:bg-black/8' : ''} ${compact ? 'mb-1' : 'mb-1.5'}`}
    >
      <div className="flex-1 min-w-0">
        <p className={`text-xs font-semibold ${nameColor} leading-tight`}>
          {repliedTo.author_name}
        </p>
        <p className={`text-xs text-gray-500 leading-tight line-clamp-2 whitespace-pre-line ${repliedTo.deleted ? 'italic' : ''}`}>
          {bodyPreview}
        </p>
      </div>
      {repliedTo.image_url && !repliedTo.deleted && (
        <img
          src={repliedTo.image_url}
          alt=""
          className="w-10 h-10 rounded object-cover ml-2 flex-shrink-0"
        />
      )}
    </div>
  )
}
